import React, { useState, useMemo, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useGlobalContext, useStaffContext } from 'store';
import { useCityName } from 'service/city';
import { MenuLayout, Breadcrumb, Setting } from 'component';
import logo from 'assets/img/logo.png';

const Home = () => {
    const { pathname } = useLocation();
    const { menuPosition } = useGlobalContext();
    const { pages, setPages } = useStaffContext();
    const cityName = useCityName();
    const [currPath, setCurrPath] = useState(pathname.split('/')[1]);
    const navigate = useNavigate();

    useEffect(() => {
        if (cityName?.length > 0) {
            setPages((prev) => {
                const newPrev = JSON.parse(JSON.stringify(prev));
                newPrev[0].icon = prev[0].icon; // React Component Deep Copy 後沒辦法使用
                newPrev[0].name = `${cityName}政府平台`;
                return newPrev;
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cityName]);

    const onClickMenu = (path) => {
        setCurrPath(path);
        navigate(path);
    };

    const currRoute = useMemo(() => {
        const findRoute = (list, path) => {
            let result = null;
            for (let i = 0; i < list.length; i += 1) {
                if (list[i].children?.length) {
                    result = findRoute(list[i].children, path);
                } else if (list[i].path === path) {
                    result = list[i];
                }
                if (result) {
                    break;
                }
            }
            if (result) {
                result = { path: result.path, name: result.name };
            }
            return result;
        };
        return findRoute(pages, currPath);
    }, [pages, currPath]);

    useEffect(() => {
        if (!currRoute) {
            onClickMenu(pages[0]?.children[0]?.path || '');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setCurrPath(pathname.split('/')[1]);
    }, [pathname]);

    return (
        <MenuLayout
            pages={pages}
            menuPosition={menuPosition}
            currentRouteName={currPath}
            onClickMenu={onClickMenu}
            logo={<img className="w-[90px]" src={logo} alt="" />}
            toolBar={(
                <div className="flex justify-between items-center w-full">
                    <Breadcrumb path={currPath} />
                    <Setting cityName={cityName} />
                </div>
            )}
        >
            <div className="h-full p-2 bg-white">
                <Outlet context={currRoute} />
            </div>
        </MenuLayout>
    );
};

export default Home;
